export const action_types = {
  'REQUEST_PREFERENCES': 'REQUEST_PREFERENCES',
  'SUCCESS_PREFERENCES': 'SUCCESS_PREFERENCES',
  'ERROR_PREFERENCES': 'ERROR_PREFERENCES',
  'ERROR_SUBMIT_PREFERENCES': 'ERROR_SUBMIT_PREFERENCES',
  'REQUEST_SUBMIT_PREFERENCES': 'REQUEST_SUBMIT_PREFERENCES',
  'SUCCESS_SUBMIT_PREFERENCES': 'SUCCESS_SUBMIT_PREFERENCES'
}